import Info from '@clearkit/icons/glyphs/Info';
import { CKButton, CKIconStack } from '@clearkit/react';
import moment from 'moment';

import Logo from '~/components/ConfigurationLogo';
import { purposeForConnectorService } from '~/lib/configuration';
import history from '~/lib/history';
import paths from '~/lib/paths';

import styles from './styles.js';

const ACCOUNT_CONNECTOR_TYPES = [
  'account_connector_auth',
  'account_connector_terms',
  'account_connector_confirm_user',
  'salesforce_user_api_disabled',
];
const DESTINATION_TYPES = ['destination_archived_slack_channel'];

const documentationLinks = {
  account_connector_terms:
    'https://help.clearbit.com/hc/en-us/articles/360043723133-Troubleshooting-Facebook-Ads',
  salesforce_user_api_disabled:
    'https://help.clearbit.com/hc/en-us/articles/360056896793-Troubleshooting-Salesforce-Syncs',
};

function AccountNotification({
  classes,
  accountNotification,
  className,
  icon,
  showResolveButton,
  fixIssue,
}) {
  const {
    sourceName,
    notificationType,
    message,
    createdAt,
    updatedAt,
    segmentType,
    segmentId,
    sourceId,
  } = accountNotification;

  const isAccountConnectorNotification = ACCOUNT_CONNECTOR_TYPES.some(
    (type) => notificationType === type,
  );

  const isDestinationNotification = DESTINATION_TYPES.some(
    (type) => notificationType === type,
  );

  let resolve = fixIssue;
  let helpText = 'Fix this issue';
  if (isDestinationNotification) {
    resolve = () =>
      history.push(
        paths.segmentDestinationEdit(segmentType, segmentId, sourceId),
      );
  } else if (documentationLinks[notificationType]) {
    helpText = 'Read the docs';
    resolve = () => window.open(documentationLinks[notificationType]);
  }

  return (
    <div className={classnames(classes.notification, className)}>
      <div className="flex items-center mr-4">
        {(() => {
          if (icon) {
            return icon;
          }

          if (isAccountConnectorNotification || isDestinationNotification) {
            return (
              <CKIconStack
                base={<Logo type={sourceName} />}
                badge={<Info className="fill-gradient-br-yellow" />}
              />
            );
          }

          return (
            <Info className="fill-gradient-br-yellow" width={26} height={26} />
          );
        })()}
      </div>
      <div className="flex-1">
        <span className="block text-sm font-medium leading-tight text-yellow-800">
          {message ||
            `There was an error ${purposeForConnectorService(sourceName)}`}
        </span>
        {(() => {
          if (
            (!isAccountConnectorNotification && !isDestinationNotification) ||
            !sourceName
          ) {
            return null;
          }
          const action =
            notificationType === 'account_connector_auth'
              ? 'Reconnect'
              : 'Resolve';

          return (
            <span className="text-sm text-yellow-800">
              {action} to continue {purposeForConnectorService(sourceName)}
            </span>
          );
        })()}
      </div>
      <span className="text-sm text-yellow-800">
        {(() => {
          const date = updatedAt || createdAt;
          return date && moment(date).calendar();
        })()}
      </span>
      <div className="ml-4">
        {showResolveButton && (
          <CKButton variantColor="yellow" variant="bold" onClick={resolve}>
            {helpText}
          </CKButton>
        )}
      </div>
    </div>
  );
}

AccountNotification.defaultProps = {
  fixIssue: () => history.push(paths.configurations()),
  showResolveButton: true,
};

AccountNotification.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  accountNotification: PropTypes.object.isRequired,
};

export default withStyles(styles)(AccountNotification);
